<template>
  <div class="channel-group-page">
    <!-- 搜索/新增 -->
    <div class="channel-hd">
      <el-form
        :inline="true"
        v-model="searchValue"
        ref="addform"
        class="demo-form-inline"
      >
        <el-form-item label="">
          <el-input
            placeholder="渠道包组名称"
            v-model="searchValue.group_name"
          ></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="searchChannelList">搜索</el-button>
        </el-form-item>
        <el-form-item>
          <el-button @click="reset()">重置</el-button>
        </el-form-item>
      </el-form>
      <el-button type="primary" icon="el-icon-plus" @click="channelAddDialog"
        >新建渠道包组</el-button
      >
    </div>
    <el-table
      stripe
      ref="table"
      v-loading="loadingData"
      :data="tableData"
      :max-height="tableHeight"
      border
      style="width: 100%"
    >
      <el-table-column prop="group_name" label="渠道包组名称"> </el-table-column>
      <el-table-column prop="channel_name" label="渠道">
        <template slot-scope="scope">
          <p class="ellipsis">{{ scope.row.channel_name }}</p>
        </template>
      </el-table-column>
      <el-table-column prop="updated_at" label="更新时间"> </el-table-column>
      <el-table-column prop="sort" label="排序权重"></el-table-column>
      <el-table-column label="操作">
        <template slot-scope="scope">
          <el-button
            type="primary"
            plain
            @click="channelEditDialog(scope.row)"
            title=""
            >编辑</el-button
          >
          <el-tooltip effect="dark" content="将排序置顶至最高权重0" placement="top-start">
            <el-button
              type="success"
              plain
              @click="channelEditDialog(scope.row, true)"
              title=""
              >置顶</el-button
            >
          </el-tooltip>
          <el-button
            type="danger"
            plain
            @click="channelsDelete(scope.row.id)"
            title=""
            >删除</el-button
          >
        </template>
      </el-table-column>
    </el-table>

    <!-- 分页 -->
    <div class="pagination">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-sizes="[10, 20, 30, 40]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="totalRecords"
      >
      </el-pagination>
    </div>

    <!-- 添加渠道对话框 -->
    <el-dialog
      title="渠道包组新增"
      :visible.sync="addDialogFormVisible"
      :close-on-click-modal="false"
    >
      <el-form :model="addform" label-width="100px" ref="addform">
        <el-form-item label="渠道包组名称">
          <el-input
            v-model="addform.group_name"
            placeholder="输入内容"
            style="width: 280px"
          ></el-input>
        </el-form-item>
        <el-form-item label="游戏">
          <el-select
            v-model="game_id"
            filterable
            clearable
            multiple
            placeholder="选择选项"
            style="width: 280px"
            @change="(val) => getGamePackagesSelectList(val)"
          >
            <el-option
              v-for="item in gamesList"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="游戏母包">
          <el-select
            v-model="game_package_id"
            filterable
            clearable
            multiple
            placeholder="选择选项"
            style="width: 280px"
          >
            <el-option
              v-for="item in gamesPackageList"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="排序">
          <el-input-number v-model="addform.sort" :min="0" :max="9999"></el-input-number>
          <el-tooltip style="margin-left: 10px;" effect="dark" content="数值越低权重越高，最高权重为0" placement="top-start">
            <i class="el-icon-warning-outline"></i>
          </el-tooltip>
        </el-form-item>
        <el-form-item label="渠道">
          <el-input
            style="margin-bottom: 10px;"
            placeholder="搜索渠道"
            v-model="addSearchChannel"
            clearable>
          </el-input>
          <el-button type="primary"
            size="small"
            @click="() => {
              const channelPackageList = packageList.map(({id}) => id)
              const extraIds = addform.group_channel_package_ids.filter(id => !channelPackageList.includes(id))
              addform.group_channel_package_ids = extraIds.concat(packageList.map(({id}) => id))
            }">全选</el-button>
          <el-button type="success"
            size="small"
            @click="() => {
              const channelPackageList = packageList.map(({id}) => id)
              const extraIds = addform.group_channel_package_ids.filter(id => !channelPackageList.includes(id))
              addform.group_channel_package_ids = extraIds.concat(channelPackageList.filter(id => !addform.group_channel_package_ids.includes(id)))
            }">反选</el-button>
          <el-checkbox-group v-model="addform.group_channel_package_ids">
            <el-checkbox
              v-for="(item, i) in packageList"
              :key="i"
              :label="item.id"
              class="channel-checkbox"
              >{{ item.name }}</el-checkbox
            >
          </el-checkbox-group>
          <el-collapse v-model="addActiveName" accordion>
            <el-collapse-item title="已选中渠道" name="1">
              <span
                v-for="channel in channelPackagesList.filter(item => addform.group_channel_package_ids.includes(item.id))"
                :key="channel.id"
                style="color:#4290f7;">{{channel.name}}<b style="color:red; padding: 0 5px;">|</b></span>
            </el-collapse-item>
          </el-collapse>
          <el-button type="danger"
            size="small"
            @click="() => {
              addform.group_channel_package_ids = []
            }">清空</el-button>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="addDialogFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="addchannelSubmit('addform')"
          >确 定</el-button
        >
      </div>
    </el-dialog>

    <!-- 编辑渠道对话框 -->
    <el-dialog
      title="编辑渠道包组数据"
      :visible.sync="editDialogFormVisible"
      :close-on-click-modal="false"
    >
      <el-form :model="editform" label-width="100px" ref="editform">
        <el-form-item label="渠道包组名称">
          <el-input
            v-model="editform.group_name"
            placeholder="输入内容"
            style="width: 280px"
          ></el-input>
        </el-form-item>
        <el-form-item label="游戏">
          <el-select
            v-model="game_id"
            filterable
            clearable
            multiple
            placeholder="选择选项"
            style="width: 280px"
            @change="(val) => getGamePackagesSelectList(val)"
          >
            <el-option
              v-for="item in gamesList"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="游戏母包">
          <el-select
            v-model="game_package_id"
            filterable
            clearable
            multiple
            placeholder="选择选项"
            style="width: 280px"
          >
            <el-option
              v-for="item in gamesPackageList"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="排序">
          <el-input-number v-model="editform.sort" :min="0" :max="9999"></el-input-number>
          <el-tooltip style="margin-left: 10px;" effect="dark" content="数值越低权重越高，最高权重为0" placement="top-start">
            <i class="el-icon-warning-outline"></i>
          </el-tooltip>
        </el-form-item>
        <el-form-item label="渠道">
          <el-input
            style="margin-bottom: 10px;"
            placeholder="搜索渠道"
            v-model="searchChannel"
            clearable>
          </el-input>
          <el-button type="primary"
            size="small"
            @click="() => {
              const channelPackageList = packageList.map(({id}) => id)
              const extraIds = editform.group_channel_package_ids.filter(id => !channelPackageList.includes(id))
              editform.group_channel_package_ids = extraIds.concat(editChannelPackageList.map(({id}) => id))
            }">全选</el-button>
          <el-button type="success"
            size="small"
            @click="() => {
              const channelPackageList = editChannelPackageList.map(({id}) => id)
              const extraIds = editform.group_channel_package_ids.filter(id => !channelPackageList.includes(id))
              editform.group_channel_package_ids = extraIds.concat(channelPackageList.filter(id => !editform.group_channel_package_ids.includes(id)))
            }">反选</el-button>
          <el-checkbox-group v-model="editform.group_channel_package_ids">
            <el-checkbox
              v-for="(item, i) in editChannelPackageList"
              :key="i"
              :label="item.id"
              class="channel-checkbox"
              >{{ item.name }}</el-checkbox
            >
          </el-checkbox-group>
          <el-collapse v-model="activeName" accordion>
            <el-collapse-item title="已选中渠道" name="1">
              <span
                v-for="channel in channelPackagesList.filter(item => editform.group_channel_package_ids.includes(item.id))"
                :key="channel.id"
                style="color:#4290f7;">{{channel.name}}<b style="color:red; padding: 0 5px;">|</b></span>
            </el-collapse-item>
          </el-collapse>
          <el-button type="danger"
            size="small"
            @click="() => {
              editform.group_channel_package_ids = []
            }">清空</el-button>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="editDialogFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="editchannelSubmit('editform')"
          >确 定</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { mapState } from "vuex";
import fetch from "@/assets/js/axios.js";
import { throttle } from "@/assets/js/public.js";
import _ from "lodash"
export default {
  name: "channelGroup",
  components: {},
  data() {
    return {
      loadingData: false,
      searchValue: {
        group_name: "",
      },
      tableHeight: 0,
      historyValue: {},
      tableData: [],
      gamesList: [],
      gamesPackageList: [],
      totalRecords: 0,
      currentPage: 1,
      pageSize: 10,
      game_id: "",
      game_package_id: "",
      addDialogFormVisible: false,
      editDialogFormVisible: false,
      channelPackagesList: [],
      channelPackagesAllList: [],
      addform: {
        group_name: "",
        group_channel_package_ids: [],
        sort: 9999,
      },
      editform: {
        id: "",
        group_name: "",
        group_channel_package_ids: [],
        sort: 9999,
      },
      channels_id: [],
      searchChannel: '',
      addSearchChannel: '',
      activeName: '1',
      addActiveName: '1',
    };
  },
  computed: {
    ...mapState(["host"]),
    packageList () {
      let list = _.cloneDeep(this.channelPackagesList)
      if (this.game_id && this.game_id.length) list = list.filter(item => this.game_id.includes(item.game_id))
      if (this.game_package_id && this.game_package_id.length) list = list.filter(item => this.game_package_id.includes(item.game_package_id))
      return this.addSearchChannel ? list.filter(item => item.name.includes(this.addSearchChannel)) : list
    },
    editChannelPackageList () {
      let list = _.cloneDeep(this.channelPackagesList)
      if (this.game_id && this.game_id.length) list = list.filter(item => this.game_id.includes(item.game_id))
      if (this.game_package_id && this.game_package_id.length) list = list.filter(item => this.game_package_id.includes(item.game_package_id))
      return this.searchChannel ? list.filter(item => item.name.includes(this.searchChannel)) : list
    },
  },
  created() {
    this.channelPackagesSelect();
    this.getGameSelectList();
    this.getGamePackagesSelectList()
    this.getChannelGroupList(true);
  },
  updated() {
    this.$nextTick(() => {
      this.$refs["table"].doLayout();
    });
  },
  beforeMount(height) {
    var h = document.documentElement.clientHeight;
    this.tableHeight = h - 60; //减去页面上固定高度height
  },

  methods: {
    //   分页
    handleSizeChange(val) {
      this.pageSize = val;
      this.getChannelGroupList(false);
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.getChannelGroupList(false);
    },
    // 实现渠道数据的搜索
    searchChannelList() {
      this.currentPage = 1;
      this.getChannelGroupList(true);
    },
    // 重置
    reset() {
      this.searchValue = {
        group_name: "",
      };
      this.currentPage = 1;
      this.getChannelGroupList(true);
    },
    // 渠道包 下拉选择列表
    channelPackagesSelect() {
      fetch({
        url: "/admin/game_channel_packages/channel_package_select",
        method: "GET",
      }).then((res) => {
        this.channelPackagesList = res.data.data;
        this.channelPackagesAllList = res.data.data;
      });
    },
    // 获取游戏选择列表数据
    getGameSelectList() {
      fetch({
        url: "/admin/games/select",
        method: "GET",
      }).then((res) => {
        this.gamesList = res.data.data;
      });
    },
    // 获取游戏母包列表数据
    getGamePackagesSelectList(val = []) {
      this.game_package_id = ''
      fetch({
        url: "/admin/game_packages/select",
        method: "GET",
        params: {game_ids: val.toString()}
      }).then((res) => {
        this.gamesPackageList = res.data.data;
      });
    },
    // 显示新增渠道对话框
    channelAddDialog: throttle(function () {
      this.addform = {
        group_name: "",
        group_channel_package_ids: [],
        sort: 9999,
      };
      this.addDialogFormVisible = true;
    }, 1000),

    // 实现渠道数据的新增
    addchannelSubmit(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          fetch({
            url: "/admin/channel_package_group/create",
            method: "POST",
            data: {
              ...this.addform,
              group_channel_package_ids: this.addform.group_channel_package_ids.toString(),
            },
          }).then((res) => {
            if (res.data.status === 1) {
              this.$message({
                type: "success",
                message: "添加成功",
              });
              this.getChannelGroupList();
              this.addDialogFormVisible = false;
            } else {
              this.$message.error(res.data.message);
            }
          });
        }
      });
    },
    // 编辑渠道对话框--加载默认数据
    channelEditDialog(row, isSort = false) {
      this.game_id = ''
      this.editform.group_channel_package_ids = [];
      let group_channel_package_ids = row.group_channel_package_ids.split(",");
      let that = this;
      group_channel_package_ids.forEach((item, i) => {
        let ids = parseInt(item);
        that.editform.group_channel_package_ids.push(ids);
      });

      this.editform.id = row.id;
      this.editform.group_name = row.group_name;
      this.editform.sort = row.sort;
      if (isSort) {
        this.editSubmit(true)
      } else {
        this.editDialogFormVisible = true;
      }
    },
    // 实现渠道的编辑操作
    editchannelSubmit(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) this.editSubmit()
      });
    },
    editSubmit(sortTop = false) {
      const data = {
        ...this.editform,
        group_channel_package_ids: this.editform.group_channel_package_ids.toString(),
      }
      if (sortTop) data['sort'] = 0
      fetch({
        url: "/admin/channel_package_group/edit",
        method: "POST",
        data,
      }).then((res) => {
        if (res.data.status === 1) {
          this.$message({
            type: "success",
            message: (sortTop ? '置顶' : '编辑') + "成功",
          });
          this.getChannelGroupList();
          this.editDialogFormVisible = false;
        } else {
          this.$message.error(res.data.message);
        }
      });
    },

    // 删除提示
    channelsDelete(id) {
      this.$confirm("是否确定删除渠道包组?", "操作确认", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.channelsDelSubmit(id);
        })
        .catch(() => {});
    },
    // 删除提交
    channelsDelSubmit(id) {
      fetch({
        url: "/admin/channel_package_group/del",
        method: "GET",
        params: {
          id: id,
        },
      }).then((res) => {
        if (res.data.status) {
          this.$message({
            type: "success",
            message: "删除成功！",
          });
          this.getChannelGroupList();
        } else {
          this.$message.error(res.data.message);
        }
      });
    },
    // 展示渠道列表数据
    getChannelGroupList(reload = false) {
      let searchValue = {};
      if (reload) {
        this.historyValue = JSON.parse(JSON.stringify(this.searchValue));
        searchValue = this.searchValue;
      } else {
        searchValue = this.historyValue;
      }
      this.loadingData = true;
      fetch({
        url: "/admin/channel_package_group/list",
        method: "GET",
        params: {
          ...searchValue, // 传对应的搜索的值
          page: this.currentPage,
          per_page: this.pageSize,
        },
      })
        .then((res) => {
          if (res.data.status) {
            this.tableData = res.data.data.data;
            this.totalRecords = res.data.data.total;
          }
        })
        .finally(() => {
          this.loadingData = false;
        });
    },
  },
};
</script>
<style lang="less">
.pagination {
  text-align: right;
  margin-top: 20px;
  padding-bottom: 20px;
}
.channel-hd {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  .el-input-group {
    width: 370px;
  }
}
.channel-group-page {
  .el-checkbox-group {
    max-height: 300px;
    overflow-y: auto;
  }
}
</style>
